module.exports = __webpack_public_path__ + "img/money-bag-grey.cc84b527.png";